import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Divider,
  Grid2,
  Avatar,
  Stack,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import { useAuth } from '../AuthContext';

export default function UserMenu() {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  let auth = useAuth();
  let navigate = useNavigate();

  return (
    <Box sx={{ ml: 1 }}>
      <IconButton
        edge="start"
        color="inherit"
        aria-controls={open ? 'account-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        // sx={{ ml: 1 }}
        id="account-button"
        onClick={handleClick}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="account-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem sx={{ minWidth: 200 }} disabled>
          <Stack
            direction="row"
            sx={{
              // p: 2,
              gap: 1,
              alignItems: 'center',
            }}
          >
            <Avatar
              sizes="small"
              alt={auth.user.email.toUpperCase()}
              src="/static/images/avatar/7.jpg"
              sx={{ width: 36, height: 36 }}
            />        

            <Box sx={{ mr: 'auto' }}>
              <Typography>
                {auth.user.email}
              </Typography>
            </Box>
          </Stack>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleClose} to="/" component={Link}>Home</MenuItem>
        <MenuItem onClick={handleClose} to="/account" component={Link}>Account</MenuItem>
        <MenuItem
          onClick={async () => {
            await auth.signout();
            handleClose();
            navigate("/");
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  )
}